import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MenuOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'

import { updateDishDrawer, updateDishTableHotkeys } from '../../redux/actions'
import { StyledDrawerButton } from '../styled'

const DishDrawerButton = ({ dishId, drawerType }) => {
  const dispatch = useDispatch()
  const { selectedDishId, selectedDrawerType } = useSelector(
    store => store.dishes.dishes?.drawer,
  )

  const isActive = useMemo(
    () => selectedDishId === dishId && selectedDrawerType === drawerType,
    [dishId, drawerType, selectedDishId, selectedDrawerType],
  )

  const handleToggleDrawerVisibility = useCallback(() => {
    const shouldClose =
      selectedDishId === dishId && selectedDrawerType === drawerType

    dispatch(
      updateDishTableHotkeys({ isDrawerNavigationEnabled: !shouldClose }),
    )

    if (shouldClose) {
      return dispatch(
        updateDishDrawer({ selectedDishId: null, selectedDrawerType: null }),
      )
    }

    return dispatch(
      updateDishDrawer({
        selectedDishId: dishId,
        selectedDrawerType: drawerType,
      }),
    )
  }, [dishId, dispatch, drawerType, selectedDishId, selectedDrawerType])

  return (
    <StyledDrawerButton
      icon={<MenuOutlined />}
      isActive={isActive}
      shape="circle"
      onClick={handleToggleDrawerVisibility}
    />
  )
}

DishDrawerButton.propTypes = {
  dishId: PropTypes.string.isRequired,
  drawerType: PropTypes.string.isRequired,
}

export default DishDrawerButton
